var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block_image"},[_c('img',{staticClass:"block w-full",attrs:{"src":_vm.url,"alt":_vm.title}})])}
var staticRenderFns = []

export { render, staticRenderFns }